import React from "react";

import Constants from "../config.js";


/**
 * WaitlistButton — mock-wallet-only call-to-action linking to the
 * TokkenR waitlist Google Form. Opens in a new tab.
 *
 * Props:
 *   - variant: "full" (subtitle + button, for the Tokens home page)
 *              "compact" (button only, for the menu bottom)
 *   - style: React.CSSProperties (optional overrides)
 */
const WaitlistButton = ({ variant = "full", style }) => {
	const href = Constants.WAITLIST_URL

	if (variant === "full") {
		return (
			<div style={{ textAlign: "center", margin: "1.5em 0" }}>
				<div style={{
					fontSize: "14px",
					color: "lightgrey",
					marginBottom: "10px",
					padding: "0 8px",
				}}>
					This is an example wallet — join the waitlist to get early access.
				</div>
				<a
					className="waitlistButton"
					href={href}
					target="_blank"
					rel="noopener noreferrer"
				>
					Join the waitlist
				</a>
			</div>
		)
	}

	// compact: button only, full-width inside a menu
	return (
		<a
			className="waitlistButton"
			href={href}
			target="_blank"
			rel="noopener noreferrer"
			style={{ width: "100%", margin: "0 0 8px", ...style }}
		>
			Join the waitlist
		</a>
	)
}

export default WaitlistButton
